<template>
	<div class="print-solicitacao" v-if="exibir">
		<div class="row print">
			<flCabecalho widthimg="130" top="16" />
		</div>

		<div class="table-responsive" style="margin-top: 8px">
			<table style="width: 100%">
				<tr>
					<td>
						<table class="table table-bordered table-condensed table-siga">
							<thead>
								<tr>
									<th colspan="7" style="background: #eee" class="text-center">
										{{ form.numero }} - {{ _traducao('global', 'despachoAeronaves').toUpperCase() }}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<strong>{{ _traducao('global', 'codigo') }}:</strong><br />
										{{ form.numero }}
									</td>
									<td>
										<strong>{{ _traducao('global', 'status') }}:</strong><br />
										<span v-if="form.status == 'E'">{{ _traducao('global', 'encerrada').toUpperCase() }}</span>
										<span v-if="form.status == 'A'">{{ _traducao('global', 'aberta').toUpperCase() }}</span>
									</td>
									<td>
										<strong>{{ _traducao('global', 'tipo') }}:</strong><br />
										<span v-if="form.tipo == 'E'">{{ _traducao('global', 'emergencial').toUpperCase() }}</span>
										<span v-if="form.tipo == 'C'">{{ _traducao('global', 'critica').toUpperCase() }}</span>
										<span v-if="form.tipo == 'P'">{{ _traducao('global', 'planejada').toUpperCase() }}</span>
									</td>
									<td>
										<strong>{{ _traducao('global', 'inicio') }}:</strong><br />
										{{ form.data_inicio }}
									</td>
									<td>
										<strong>{{ _traducao('global', 'numReds') }}:</strong><br />
										{{ form.numero_bo | na }}
									</td>
									<td>
										<strong>{{ _traducao('global', 'numChamada') }}:</strong><br />
										{{ form.numero_chamada | na }}
									</td>
								</tr>
								<tr>
									<td>
										<strong>{{ _traducao('global', 'aeronave') }}(s):</strong><br />
									</td>
									<td colspan="6">
										<span v-for="(aero, idx) in form.aeronave" :key="idx">
											<div v-for="(a, i) in aeronaves" :key="i">
												<span v-if="a.id == aero.id_aeronave">
													<span v-for="b in bases" :key="b.descricao"
														><span v-if="b.id == aero.base">{{ b.descricao }}</span></span
													><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ a.codinome }} - {{ a.prefixo }}
													<span v-for="(it, idxTrip) in aero.tripulacao" :key="it.trigrama"
														><br />
														&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
														<span v-if="aero.voo_instrucao == '1' && idxTrip == 0">
															{{ _traducao('global', 'instrutorVoo').toUpperCase() }}
														</span>
														<span v-else>
															{{ it.funcao.toUpperCase() }}
														</span>
														<i class="fa fa-fw fa-long-arrow-right" aria-hidden="true"></i>{{ it.nome }}</span
													>
												</span>
											</div>
										</span>
									</td>
								</tr>
								<tr>
									<td style="width: 15%">
										<strong>{{ _traducao('global', 'classificacao') }}:</strong>
									</td>
									<td colspan="6">
										{{ form.subclassificacao._descricao }}
									</td>
								</tr>

								<tr>
									<td style="width: 15%">
										<strong>{{ _traducao('global', 'contextoOperativo') }}:</strong>
									</td>
									<td colspan="6">
										<span v-if="form.houve_contexto == '1'">{{ form.contexto_operativo.descricao.toUpperCase() }}</span>
										<span v-if="form.houve_contexto == '0'">N/A</span>
									</td>
								</tr>
								<tr v-if="_idCliente == 14 && form.demanda_reprimida == '1'">
									<td style="width: 15%">
										<strong>{{ _traducao('global', 'demandaReprimida') }}</strong>
									</td>
									<td>
										{{ _traducao('global', 'sim').toUpperCase() }}
									</td>
									<td>
										<strong>{{ _traducao('global', 'motivo') }}:</strong>
									</td>
									<td colspan="4">
										{{ form.descricao_demanda_reprimida }}
									</td>
								</tr>
								<tr>
									<td>
										<strong>{{ _traducao('global', 'motivacao') }}:</strong>
									</td>
									<td colspan="6">
										{{ form.historico }}
									</td>
								</tr>
							</tbody>
						</table>

						<table
							v-if="form.id_ordem_missao != null"
							class="table table-bordered table-condensed table-siga"
							style="margin-top: 8px"
						>
							<thead>
								<tr>
									<th colspan="3" style="background: #eee" class="text-center">
										{{ form.ordem_codigo }} - {{ _traducao('menuOrdemMissao', 'menuOrdemmissao').toUpperCase() }}
									</th>
								</tr>
								<tr>
									<th>{{ _traducao('global', 'codigo') }}</th>
									<th>{{ _traducao('global', 'dataInicio') }}</th>
									<th>{{ _traducao('global', 'descricao') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										{{ form.ordem_codigo }}
									</td>
									<td>
										{{ form.ordem_data_inicio | dataTempo }}
									</td>
									<td>
										{{ form.ordem_descricao }}
									</td>
								</tr>
							</tbody>
						</table>

						<table
							v-if="form.id_solicitacao != null && form.id_solicitacao != ''"
							class="table table-bordered table-condensed table-siga"
							style="margin-top: 8px"
						>
							<thead>
								<tr>
									<th colspan="3" style="background: #eee" class="text-center">
										{{ form.solicitacao_codigo }} - SOLICITAÇÃO DE USO DE AERONAVE
									</th>
								</tr>
								<tr>
									<th>{{ _traducao('global', 'descricao') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										{{ form.solicitacao_descricao }}
									</td>
								</tr>
							</tbody>
						</table>

						<table v-if="form.codigo_prevencao" class="table table-bordered table-condensed table-siga" style="margin-top: 8px">
							<thead>
								<tr>
									<th colspan="4" style="background: #eee" class="text-center">
										{{ form.codigo_prevencao }} - {{ _traducao('global', 'ordemMissaoPrevencaoQualificada').toUpperCase() }}
									</th>
								</tr>
								<tr>
									<th>{{ _traducao('global', 'codigo') }}:</th>
									<th>{{ _traducao('global', 'dataInicio') }}:</th>
									<th>{{ _traducao('global', 'dataFim') }}:</th>
									<th>{{ _traducao('global', 'descricao') }}:</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										{{ form.codigo_prevencao }}
									</td>
									<td>
										{{ form.inicio_prevencao | dataTempo }}
									</td>
									<td>
										{{ form.fim_prevencao | dataTempo }}
									</td>
									<td>
										{{ form.descricao_prevencao }}
									</td>
								</tr>
							</tbody>
						</table>
						<pre style="display: none">{{ form }}</pre>
						<flDiarioResumido ref="relatorioVoo"></flDiarioResumido>
					</td>
				</tr>
			</table>
		</div>

		<flGeradoPor />
	</div>
</template>

<script>
import flDiarioResumido from '../../../../mg-siga/print/resumo.vue'
export default {
	components: {
		flDiarioResumido
	},

	prop: {
		cabecalho: {
			required: true,
			type: Boolean
		}
	},

	data() {
		return {
			exibir: false,
			form: {},
			bases: [],
			aeronaves: []
		}
	},

	mounted() {
		this._providerAeronave((lista) => (this.aeronaves = lista))
		this._providerBaseOperacional((lista) => (this.bases = lista))
	},

	methods: {
		carregaDados(form) {
			this.exibir = true
			this.form = form

			this.$nextTick(() => {
				this.$refs.relatorioVoo.carrega(this.form.relatorio_voo_trecho)
			})
		}
	}
}
</script>